var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBiasFreeDecisionMaking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 297,
    height: 284,
    viewBox: "0 0 297 284",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M280.953 67.8154C264.033 35.494 231.915 13.1018 197.28 4.61652C164.24 -3.47801 124.464 -3.07959 99.5944 23.5753C83.2186 41.126 76.661 65.5606 62.2084 84.5125C55.0248 93.9323 46.0347 98.2415 36.6225 104.835C13.6834 120.905 -3.18777 146.765 0.50952 176.013C6.69101 224.914 51.2982 251.177 96.1298 254.126C155.374 258.025 197.626 250.102 233.517 227.166C252.158 215.254 270.749 201.118 282.128 181.553C299.337 151.965 298.631 114.653 287.498 82.8831C285.666 77.6578 283.474 72.6301 280.953 67.8154Z",
    fill: "#6D519D",
    fillOpacity: 0.91
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M280.953 67.8154C264.033 35.494 231.915 13.1018 197.28 4.61652C164.24 -3.47801 124.464 -3.07959 99.5944 23.5753C83.2186 41.126 76.661 65.5606 62.2084 84.5125C55.0248 93.9323 46.0347 98.2415 36.6225 104.835C13.6834 120.905 -3.18777 146.765 0.50952 176.013C6.69101 224.914 51.2982 251.177 96.1298 254.126C155.374 258.025 197.626 250.102 233.517 227.166C252.158 215.254 270.749 201.118 282.128 181.553C299.337 151.965 298.631 114.653 287.498 82.8831C285.666 77.6578 283.474 72.6301 280.953 67.8154Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M145.254 282.622H139.169V17.7814C139.169 16.101 140.531 14.7388 142.212 14.7388C143.892 14.7388 145.254 16.101 145.254 17.7814V282.622Z",
    fill: "#604293",
    stroke: "#7A669E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M138.998 50.0156H85.6484V68.8004H138.998V50.0156Z",
    fill: "#9B85C0",
    stroke: "#7A669E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M198.707 29.8796H145.357V48.6644H198.707V29.8796Z",
    fill: "#9B85C0",
    stroke: "#7A669E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M145.357 81.6464L175.147 85.431V59.0757L145.357 62.8609V81.6464Z",
    fill: "#9B85C0",
    stroke: "#7A669E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M169.144 72.7576L162.57 65.5071V68.6689L148.838 69.2088V76.096L162.57 76.7781V79.9399L169.144 72.7576Z",
    fill: "#604293",
    stroke: "#7A669E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M190.574 37.9079L180.436 32.0547V34.6192H153.708V41.1972H180.436V43.7617L190.574 37.9079Z",
    fill: "#604293",
    stroke: "#7A669E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2021 59.5468L104.34 53.6936V56.2581H131.068V62.8361H104.34V65.4L94.2021 59.5468Z",
    fill: "#604293",
    stroke: "#7A669E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M225.095 68.8677C237.303 68.8677 247.2 58.9708 247.2 46.7623C247.2 34.5539 237.303 24.657 225.095 24.657C212.886 24.657 202.989 34.5539 202.989 46.7623C202.989 58.9708 212.886 68.8677 225.095 68.8677Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M239.631 61.3579C238.157 62.8266 236.46 64.0735 234.598 65.0437",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M231.652 66.297C229.592 66.988 227.387 67.3622 225.095 67.3622C213.718 67.3622 204.495 58.1393 204.495 46.7625C204.495 35.3857 213.718 26.1628 225.095 26.1628C236.472 26.1628 245.694 35.3857 245.694 46.7625C245.694 50.6102 244.639 54.2119 242.803 57.2934",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M225.095 48.3936C225.996 48.3936 226.726 47.6633 226.726 46.7624C226.726 45.8614 225.996 45.1311 225.095 45.1311C224.194 45.1311 223.464 45.8614 223.464 46.7624C223.464 47.6633 224.194 48.3936 225.095 48.3936Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M227.441 55.9222L225.095 46.7625L238.786 37.3848",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8198 104.116V136.779H55.4941",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5391 131.65V95.209H79.8199V101.239",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0009 136.779H35.5391V134.116",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5525 105.441H38.2305V109.763H42.5525V105.441Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3152 105.441H43.9932V109.763H48.3152V105.441Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0769 105.441H49.7549V109.763H54.0769V105.441Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8396 105.441H55.5176V109.763H59.8396V105.441Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6023 105.441H61.2803V109.763H65.6023V105.441Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M71.365 105.441H67.043V109.763H71.365V105.441Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1277 105.441H72.8057V109.763H77.1277V105.441Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5525 112.262H38.2305V116.584H42.5525V112.262Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3152 112.262H43.9932V116.584H48.3152V112.262Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0769 112.262H49.7549V116.584H54.0769V112.262Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8396 112.262H55.5176V116.584H59.8396V112.262Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6023 112.262H61.2803V116.584H65.6023V112.262Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M71.365 112.262H67.043V116.584H71.365V112.262Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1277 112.262H72.8057V116.584H77.1277V112.262Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5525 119.083H38.2305V123.405H42.5525V119.083Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3152 119.083H43.9932V123.405H48.3152V119.083Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0769 119.083H49.7549V123.405H54.0769V119.083Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8396 119.083H55.5176V123.405H59.8396V119.083Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6023 119.083H61.2803V123.405H65.6023V119.083Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M71.365 119.083H67.043V123.405H71.365V119.083Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1277 119.083H72.8057V123.405H77.1277V119.083Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5525 125.903H38.2305V130.225H42.5525V125.903Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3152 125.903H43.9932V130.225H48.3152V125.903Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0769 125.903H49.7549V130.225H54.0769V125.903Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8396 125.903H55.5176V130.225H59.8396V125.903Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6023 125.903H61.2803V130.225H65.6023V125.903Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M71.365 125.903H67.043V130.225H71.365V125.903Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1277 125.903H72.8057V130.225H77.1277V125.903Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3721 98.1433H41.4648V91.1484H43.3728L43.3721 98.1433ZM51.0032 91.1484H49.0953V98.1433H51.0032V91.1484ZM58.6337 91.1484H56.7257V98.1433H58.6337V91.1484ZM66.2641 91.1484H64.3562V98.1433H66.2641V91.1484ZM73.8946 91.1484H71.9873V98.1433H73.8946V91.1484Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6797 164.723C48.3516 164.723 40.79 172.284 40.79 181.612C40.79 190.94 48.3516 198.502 57.6797 198.502C67.0077 198.502 74.5693 190.94 74.5693 181.612C74.5693 172.284 67.0077 164.723 57.6797 164.723ZM57.6797 192.297C51.7787 192.297 46.9945 187.513 46.9945 181.612C46.9945 175.711 51.7787 170.927 57.6797 170.927C63.5807 170.927 68.3648 175.711 68.3648 181.612C68.3655 187.514 63.5813 192.297 57.6797 192.297Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0244 164.731V170.944C63.7648 171.128 68.3647 175.827 68.3647 181.612C68.3647 184.537 67.1867 187.186 65.2826 189.116L70.1554 192.996C72.8965 189.994 74.5692 185.999 74.5692 181.612C74.5692 172.4 67.1924 164.916 58.0244 164.731Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4756 180.923H63.5402",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4756 184.025H63.5402",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M210.896 105.795H243.756",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M197.801 105.795H201.184",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M221.84 111.008H243.757",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M197.801 111.008H201.452",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M232.382 116.222H243.757",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M197.801 116.222H201.184",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M241.724 121.436H243.757",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M197.801 121.436H201.184",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M241.724 127.502H243.757",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M197.801 127.502H201.184",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M241.724 133.57H243.757",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M197.801 133.57H201.184",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M209.667 102.186H202.048V134.125H209.667V102.186Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M220.095 108.201H212.476V134.126H220.095V108.201Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M230.522 113.815H222.902V134.125H230.522V113.815Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M240.949 121.035H233.329V134.125H240.949V121.035Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8629 30.5504C65.7425 28.2217 61.8724 26.8435 57.6798 26.8435C47.3433 26.8435 38.9639 35.223 38.9639 45.5595C38.9639 55.8959 47.3433 64.2754 57.6798 64.2754C68.0163 64.2754 76.3958 55.8959 76.3958 45.5595C76.3958 40.6312 74.491 36.1486 71.3783 32.8057",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8633 54.1339C51.0976 56.4307 54.2225 57.858 57.6801 57.858C64.4729 57.858 69.9793 52.3516 69.9793 45.5588C69.9793 38.7659 64.4729 33.2595 57.6801 33.2595C50.8873 33.2595 45.3809 38.7659 45.3809 45.5588C45.3809 48.0602 46.1273 50.3869 47.4099 52.328",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6794 51.9755C61.2233 51.9755 64.0961 49.1027 64.0961 45.5588C64.0961 42.015 61.2233 39.1421 57.6794 39.1421C54.1356 39.1421 51.2627 42.015 51.2627 45.5588C51.2627 49.1027 54.1356 51.9755 57.6794 51.9755Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M220.978 173.222C223.039 173.512 223.985 175.113 223.985 177.392V177.853H222.215V177.271C222.215 175.767 221.609 174.846 220.251 174.846C218.918 174.846 218.312 175.767 218.312 177.271C218.312 181.077 224.01 181.102 224.01 185.877C224.01 188.157 223.039 189.781 220.979 190.072V191.357H219.427V190.072C217.318 189.781 216.372 188.181 216.372 185.877V184.835H218.142V185.999C218.142 187.526 218.773 188.399 220.13 188.399C221.512 188.399 222.118 187.526 222.118 185.999C222.118 182.216 216.445 182.168 216.445 177.392C216.445 175.065 217.391 173.537 219.427 173.222V171.864H220.979V173.222H220.978Z",
    fill: "#263238"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M226.394 195.967C227.595 195.447 228.717 194.782 229.74 193.992",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M214.66 166.982C208.755 169.216 204.556 174.923 204.556 181.611C204.556 190.246 211.556 197.245 220.19 197.245C221.275 197.245 222.335 197.135 223.358 196.924",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M231.707 192.185C234.264 189.401 235.825 185.688 235.825 181.611C235.825 172.976 228.825 165.977 220.191 165.977C218.867 165.977 217.581 166.141 216.354 166.451",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M228.905 191.001C234.099 186.19 234.409 178.079 229.597 172.885C224.786 167.692 216.676 167.382 211.482 172.193C206.288 177.004 205.978 185.115 210.79 190.309C215.601 195.502 223.712 195.812 228.905 191.001Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M157.552 130.278C157.552 130.278 157.708 130.26 157.99 130.226C159.838 129.998 167.083 129.027 171.232 127.387C176.014 125.496 186.913 126.497 186.913 126.497L191.695 129.945L186.246 133.504C186.246 133.504 178.572 130.945 173.234 131.168C167.896 131.39 165.338 132.947 162.001 132.725C158.665 132.502 154.55 130.278 154.55 130.278H157.552Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M137.116 119.456V126.613H148.909V118.326L137.116 119.456Z",
    fill: "#F0C66C",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M133.896 112.51C133.896 112.51 131.102 110.647 132.033 113.907C132.964 117.167 133.896 118.409 135.292 118.254C136.69 118.099 137.465 117.633 137 116.391C136.535 115.149 133.896 112.51 133.896 112.51Z",
    fill: "#F0C66C",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M152.558 112.51C152.558 112.51 155.352 110.647 154.42 113.907C153.489 117.167 152.558 118.409 151.16 118.254C149.763 118.099 148.987 117.633 149.453 116.391C149.919 115.149 152.558 112.51 152.558 112.51Z",
    fill: "#F0C66C",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M139.949 97.6086C139.949 97.6086 135.293 99.1608 133.74 103.507C132.188 107.853 133.586 113.131 134.361 115.304C135.137 117.477 138.863 121.668 138.863 121.668H147.245C147.245 121.668 150.35 118.719 152.057 114.839C153.765 110.958 153.765 105.525 153.765 105.525C153.765 105.525 155.162 105.991 155.162 104.128C155.162 102.265 150.816 98.6948 150.816 98.6948C150.816 98.6948 152.834 97.9191 151.437 96.8322C150.04 95.7453 145.073 96.2113 145.073 96.2113C145.073 96.2113 144.451 92.9519 139.949 97.6086Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M158.312 275.94L159.587 276.737C159.587 276.737 161.021 276.737 161.818 277.534C162.615 278.33 162.318 282.29 162.318 282.29C162.318 282.29 161.683 282.76 158.655 282.76C155.627 282.76 148.958 283.5 148.321 282.384C147.683 281.269 148.431 276.578 148.431 276.578L158.312 275.94Z",
    fill: "black",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M123.411 175.698C123.411 175.698 122.455 182.71 122.455 184.144C122.455 185.579 122.136 198.009 122.136 198.009C122.136 198.009 122.295 230.679 122.295 231.317C122.295 231.954 119.586 240.879 120.542 246.935C121.498 252.99 123.411 276.258 123.411 276.258C123.411 276.258 122.773 281.358 123.252 281.836C123.73 282.314 129.626 282.951 130.901 282.314C132.176 281.676 131.379 275.461 131.379 275.461C131.379 275.461 132.176 272.752 132.176 270.84C132.176 268.927 132.176 267.333 132.176 265.74C132.176 264.146 132.973 249.963 133.77 244.385C134.566 238.807 135.045 231.317 135.045 231.317L138.391 196.894L140.941 196.734C140.941 196.734 144.128 233.707 144.288 236.416C144.447 239.126 143.81 244.544 145.244 250.759C146.678 256.975 147.475 273.867 147.475 273.867C147.475 273.867 147.156 275.461 147.475 276.099C147.794 276.736 148.591 278.648 148.591 278.648C148.591 278.648 149.866 278.808 151.938 278.648C153.684 278.514 154.738 278.334 157.064 277.252C158.2 276.204 158.7 274.769 158.097 273.296C157.142 270.964 156.718 270.521 156.718 270.521C156.718 270.521 158.153 250.441 158.153 245.5C158.153 240.56 157.356 234.504 157.356 234.026C157.356 233.548 158.312 197.69 158.312 194.025C158.312 190.36 157.993 180.479 156.4 176.176C154.806 171.873 129.307 172.989 126.758 173.148C124.208 173.307 123.411 175.698 123.411 175.698Z",
    fill: "#0D0469",
    stroke: "#0D0469",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M132.813 196.653L146.519 196.015",
    stroke: "#473B2A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M140.782 126.294L132.176 128.366C132.176 128.366 119.746 134.422 117.037 136.016C114.327 137.609 103.65 159.124 104.128 160.239C104.606 161.355 106.678 162.789 108.749 163.108C110.821 163.427 121.339 151.474 121.339 151.474C121.339 151.474 124.367 166.455 124.367 167.092C124.367 167.73 122.614 175.379 123.411 176.654C124.208 177.929 154.806 176.654 154.806 176.654C154.806 176.654 157.037 176.813 157.356 174.742C157.675 172.67 156.719 166.614 156.719 166.614L160.225 148.287C160.225 148.287 166.922 158.445 168.423 160.08C171.033 162.922 174.272 161.731 176.002 159.602C177.509 157.746 176.161 154.183 175.683 153.068C175.205 151.952 166.759 132.988 164.209 132.191C161.659 131.394 150.981 127.569 150.981 127.569L140.782 126.294Z",
    fill: "#F0C66C",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M132.176 128.366C132.176 128.366 142.709 128.149 144.462 128.149C146.215 128.149 152.614 128.094 152.614 128.094L150.996 124.643C150.996 124.643 147.649 123.687 142.549 123.687C137.45 123.687 133.625 125.28 133.625 125.28L132.176 128.366Z",
    fill: "#F0C66C",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M118.099 143.071L121.34 151.474L115.762 145.897",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M117.036 140.319L117.423 141.322",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M134.972 165.703C134.42 166.162 133.86 166.575 133.292 166.933",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M149.547 141.594C149.547 141.594 143.72 157.522 135.917 164.864",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M163.89 139.203L160.225 148.287L166.121 141.912",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M102.693 164.224C102.693 164.224 103.809 167.889 107.315 170.598C110.821 173.308 120.224 182.232 120.224 182.232C120.224 182.232 120.064 182.869 120.224 183.666C120.383 184.463 122.933 186.535 122.933 186.535V184.941L123.57 183.666L124.208 182.073C124.208 182.073 125.801 181.435 126.28 181.116C126.758 180.798 127.076 180.32 127.076 180.32C127.076 180.32 128.829 180.638 129.945 180.638C131.061 180.638 132.654 179.523 131.698 179.204C130.742 178.885 129.786 179.204 128.511 178.567C127.236 177.929 126.598 177.292 125.323 177.292C124.048 177.292 121.977 177.292 121.977 177.292L113.212 162.949L102.693 164.224Z",
    fill: "#FF928E"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M106.465 154.428C106.465 154.428 104.606 154.981 104.128 155.459C103.65 155.937 101.26 159.603 101.738 161.515C102.216 163.427 102.853 166.137 106.997 166.933C111.14 167.73 113.371 165.977 113.69 165.499C114.009 165.021 114.794 159.383 114.157 159.383C113.519 159.383 111.778 161.515 111.778 161.515C111.778 161.515 107.031 160.44 106.074 159.643C105.118 158.846 106.465 154.428 106.465 154.428Z",
    fill: "#F0C66C",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M179.579 164.224C179.579 164.224 178.464 167.889 174.958 170.598C171.451 173.307 162.049 182.232 162.049 182.232C162.049 182.232 162.208 182.869 162.049 183.666C161.889 184.463 158.379 186.915 158.379 186.915V184.592L158.134 183.125L158.065 182.073C158.065 182.073 156.471 181.436 155.993 181.117C155.515 180.798 155.196 180.32 155.196 180.32C155.196 180.32 153.443 180.639 152.328 180.639C151.212 180.639 149.618 179.523 150.574 179.205C151.531 178.886 152.487 179.205 153.762 178.567C155.037 177.93 155.674 177.292 156.949 177.292C158.224 177.292 160.296 177.292 160.296 177.292L169.061 162.949L179.579 164.224Z",
    fill: "#FF928E"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M176.471 155.211C176.471 155.211 177.666 154.981 178.144 155.459C178.622 155.937 181.013 159.603 180.535 161.515C180.057 163.427 179.419 166.137 175.276 166.934C171.132 167.73 168.901 165.977 168.582 165.499C168.264 165.021 168.006 159.598 168.423 160.081C169.171 160.947 170.495 161.515 170.495 161.515C170.495 161.515 175.436 161.263 176.21 158.47C176.543 157.27 176.471 155.211 176.471 155.211Z",
    fill: "#F0C66C",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M130.901 282.315C131.908 281.812 131.624 277.834 131.458 276.181C130.637 276.566 129.378 277.038 127.873 277.215C125.164 277.534 123.411 276.259 123.411 276.259C123.411 276.259 122.899 281.77 123.332 282.29C123.802 282.853 129.626 282.952 130.901 282.315Z",
    fill: "black",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M243.992 282.959C243.852 282.959 243.739 282.845 243.739 282.706V249.823C243.739 249.684 243.852 249.57 243.992 249.57C244.132 249.57 244.245 249.684 244.245 249.823V282.706C244.245 282.845 244.132 282.959 243.992 282.959Z",
    fill: "#263238"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M243.745 279.739C243.745 279.739 242.014 277.267 239.789 276.03C237.564 274.794 233.855 274.794 233.855 274.794C233.855 274.794 235.834 281.964 243.745 279.739Z",
    fill: "#263238"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M243.993 279.739C243.993 279.739 245.724 277.267 247.949 276.03C250.175 274.794 253.883 274.794 253.883 274.794C253.883 274.794 251.905 281.964 243.993 279.739Z",
    fill: "#263238"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M243.745 270.838C243.745 270.838 242.014 268.366 239.789 267.129C237.564 265.893 233.855 265.893 233.855 265.893C233.855 265.893 235.834 273.064 243.745 270.838Z",
    fill: "#263238"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M243.993 270.838C243.993 270.838 245.724 268.366 247.949 267.129C250.175 265.893 253.883 265.893 253.883 265.893C253.883 265.893 251.905 273.064 243.993 270.838Z",
    fill: "#263238"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M243.745 261.938C243.745 261.938 242.014 259.466 239.789 258.229C237.564 256.993 233.855 256.993 233.855 256.993C233.855 256.993 235.834 264.163 243.745 261.938Z",
    fill: "#263238"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M243.993 261.938C243.993 261.938 245.724 259.466 247.949 258.229C250.175 256.993 253.883 256.993 253.883 256.993C253.883 256.993 251.905 264.163 243.993 261.938Z",
    fill: "#263238"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M243.745 253.038C243.745 253.038 242.014 250.565 239.789 249.329C237.564 248.093 233.855 248.093 233.855 248.093C233.855 248.093 235.834 255.262 243.745 253.038Z",
    fill: "#263238"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M243.993 253.038C243.993 253.038 245.724 250.565 247.949 249.329C250.175 248.093 253.883 248.093 253.883 248.093C253.883 248.093 251.905 255.262 243.993 253.038Z",
    fill: "#263238"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M243.993 249.824C243.993 249.824 242.015 247.162 241.914 244.618C241.815 242.075 243.487 238.765 243.487 238.765C243.487 238.765 249.547 243.766 243.993 249.824Z",
    fill: "#263238"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1075 282.959C25.9564 282.959 25.834 282.836 25.834 282.685V247.141C25.834 246.99 25.9564 246.867 26.1075 246.867C26.2585 246.867 26.3809 246.99 26.3809 247.141V282.685C26.3809 282.836 26.2585 282.959 26.1075 282.959Z",
    fill: "#263238"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8407 279.478C25.8407 279.478 23.9697 276.805 21.5646 275.469C19.1594 274.133 15.1504 274.133 15.1504 274.133C15.1504 274.133 17.2884 281.883 25.8407 279.478Z",
    fill: "#263238"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1074 279.478C26.1074 279.478 27.9784 276.806 30.3835 275.469C32.7887 274.133 36.7977 274.133 36.7977 274.133C36.7977 274.133 34.6596 281.884 26.1074 279.478Z",
    fill: "#263238"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8407 269.857C25.8407 269.857 23.9697 267.185 21.5646 265.848C19.1594 264.512 15.1504 264.512 15.1504 264.512C15.1504 264.512 17.2884 272.262 25.8407 269.857Z",
    fill: "#263238"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1074 269.857C26.1074 269.857 27.9784 267.185 30.3835 265.848C32.7887 264.512 36.7977 264.512 36.7977 264.512C36.7977 264.512 34.6596 272.262 26.1074 269.857Z",
    fill: "#263238"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8407 260.236C25.8407 260.236 23.9697 257.564 21.5646 256.227C19.1594 254.891 15.1504 254.891 15.1504 254.891C15.1504 254.891 17.2884 262.642 25.8407 260.236Z",
    fill: "#263238"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1074 260.236C26.1074 260.236 27.9784 257.564 30.3835 256.227C32.7887 254.891 36.7977 254.891 36.7977 254.891C36.7977 254.891 34.6596 262.642 26.1074 260.236Z",
    fill: "#263238"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8407 250.615C25.8407 250.615 23.9697 247.943 21.5646 246.606C19.1594 245.27 15.1504 245.27 15.1504 245.27C15.1504 245.27 17.2884 253.02 25.8407 250.615Z",
    fill: "#263238"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1074 250.615C26.1074 250.615 27.9784 247.943 30.3835 246.606C32.7887 245.27 36.7977 245.27 36.7977 245.27C36.7977 245.27 34.6596 253.02 26.1074 250.615Z",
    fill: "#263238"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1081 247.141C26.1081 247.141 23.9694 244.264 23.8611 241.514C23.7533 238.765 25.5612 235.187 25.5612 235.187C25.5612 235.187 32.1118 240.592 26.1081 247.141Z",
    fill: "#263238"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0743 282.802V266.634C49.0743 266.483 48.9519 266.361 48.8008 266.361C48.6497 266.361 48.5273 266.483 48.5273 266.634V282.803H49.0743V282.802Z",
    fill: "#263238"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M48.534 279.729C48.534 279.729 46.6631 277.057 44.2579 275.72C41.8528 274.384 37.8438 274.384 37.8438 274.384C37.8438 274.384 39.9818 282.134 48.534 279.729Z",
    fill: "#263238"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8018 279.729C48.8018 279.729 50.6727 277.057 53.0779 275.72C55.483 274.384 59.492 274.384 59.492 274.384C59.492 274.384 57.354 282.134 48.8018 279.729Z",
    fill: "#263238"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M48.534 270.108C48.534 270.108 46.6631 267.436 44.2579 266.099C41.8528 264.763 37.8438 264.763 37.8438 264.763C37.8438 264.763 39.9818 272.513 48.534 270.108Z",
    fill: "#263238"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8018 270.108C48.8018 270.108 50.6727 267.436 53.0779 266.099C55.483 264.763 59.492 264.763 59.492 264.763C59.492 264.763 57.354 272.513 48.8018 270.108Z",
    fill: "#263238"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8015 266.634C48.8015 266.634 46.6628 263.757 46.5544 261.007C46.4467 258.258 48.2546 254.68 48.2546 254.68C48.2546 254.68 54.8051 260.086 48.8015 266.634Z",
    fill: "#263238"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M222.28 282.814V267.857C222.28 267.717 222.166 267.604 222.027 267.604C221.887 267.604 221.773 267.717 221.773 267.857V282.814H222.28Z",
    fill: "#263238"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M221.779 279.971C221.779 279.971 220.049 277.499 217.823 276.262C215.598 275.026 211.89 275.026 211.89 275.026C211.89 275.026 213.868 282.196 221.779 279.971Z",
    fill: "#263238"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M222.027 279.971C222.027 279.971 223.758 277.499 225.983 276.262C228.208 275.026 231.917 275.026 231.917 275.026C231.917 275.026 229.939 282.196 222.027 279.971Z",
    fill: "#263238"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M221.779 271.07C221.779 271.07 220.049 268.598 217.823 267.361C215.598 266.125 211.89 266.125 211.89 266.125C211.89 266.125 213.868 273.295 221.779 271.07Z",
    fill: "#263238"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M222.027 271.07C222.027 271.07 223.758 268.598 225.983 267.362C228.208 266.125 231.917 266.125 231.917 266.125C231.917 266.125 229.939 273.296 222.027 271.07Z",
    fill: "#263238"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M222.026 267.856C222.026 267.856 220.048 265.194 219.948 262.65C219.848 260.107 221.521 256.797 221.521 256.797C221.521 256.797 227.581 261.799 222.026 267.856Z",
    fill: "#263238"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M265.335 282.814V267.857C265.335 267.717 265.222 267.604 265.082 267.604C264.943 267.604 264.829 267.717 264.829 267.857V282.814H265.335Z",
    fill: "#263238"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M264.835 279.971C264.835 279.971 263.104 277.499 260.879 276.262C258.653 275.026 254.945 275.026 254.945 275.026C254.945 275.026 256.923 282.196 264.835 279.971Z",
    fill: "#263238"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M265.082 279.971C265.082 279.971 266.813 277.499 269.038 276.262C271.263 275.026 274.972 275.026 274.972 275.026C274.972 275.026 272.994 282.196 265.082 279.971Z",
    fill: "#263238"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M264.835 271.07C264.835 271.07 263.104 268.598 260.879 267.361C258.653 266.125 254.945 266.125 254.945 266.125C254.945 266.125 256.923 273.295 264.835 271.07Z",
    fill: "#263238"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M265.082 271.07C265.082 271.07 266.813 268.598 269.038 267.361C271.263 266.125 274.972 266.125 274.972 266.125C274.972 266.125 272.994 273.295 265.082 271.07Z",
    fill: "#263238"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M265.082 267.856C265.082 267.856 263.103 265.194 263.003 262.651C262.904 260.107 264.576 256.797 264.576 256.797C264.576 256.797 270.636 261.799 265.082 267.856Z",
    fill: "#263238"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M291.326 282.749H295.635",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5264 282.749H285.444",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M13.876 282.749H57.6443",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiasFreeDecisionMaking);
export default __webpack_public_path__ + "static/media/Bias-Free Decision-Making.2a91a3e5482a5243337ebacad3eb45b9.svg";
export { ForwardRef as ReactComponent };